<ng-container *ngIf="supportOptions">
  <h3 class="try-something-else-header">{{ supportOptions.innerHeading }}</h3>

  <p class="try-something-else-subheader">{{ supportOptions.innerSubHeading }}</p>
  <ng-container *ngIf="formattedSupportOptions?.length > 0">
    <ul class="vm-row tiles-container">
      <ng-container *ngFor="let supportTile of formattedSupportOptions; index as i">
        <li [id]="supportTile.uid" class="tile vm-col-xs-12 vm-col-md-4">
          <div *ngIf="supportTile.type === supportOptionType.LiveChat" [id]="liveChatTagId"></div>

          <a
            *ngIf="supportTile.href; else buttonTile"
            [attr.target]="supportTile.targetNewPage ? '_blank' : ''"
            class="tile-inner"
            [href]="supportTile.href">
            <ng-template [ngTemplateOutlet]="supportTileContent"></ng-template>
          </a>

          <ng-template #buttonTile>
            <button
              *ngIf="supportTile.type === supportOptionType.LiveChat"
              type="button"
              class="tile-inner"
              [vmLiveChatV3]="liveChatTagId"
              (click)="onTileClick(supportTile)">
              <ng-template [ngTemplateOutlet]="supportTileContent"></ng-template>
            </button>
            <button
              *ngIf="supportTile.type !== supportOptionType.LiveChat"
              type="button"
              class="tile-inner"
              (click)="onTileClick(supportTile)">
              <ng-template [ngTemplateOutlet]="supportTileContent"></ng-template>
            </button>
          </ng-template>

          <ng-template #supportTileContent>
            <img class="tile-inner-img" [alt]="supportTile.alt" src="{{ strapiURL }}{{ supportTile.imgUrl }}" />
            <h4 class="tile-inner-heading">{{ supportTile.heading }}</h4>
            <div class="tile-inner-text" [innerHtml]="supportTile?.subHeading | markdown"></div>
          </ng-template>
        </li>
      </ng-container>
    </ul>

    <button
      *ngIf="accessibilitySupportLink"
      [id]="accessibilitySupportLink.uid"
      type="button"
      class="accessibility-support-link"
      (click)="onTileClick(accessibilitySupportLink)">
      {{ accessibilitySupportLink.heading }}
    </button>

    <div class="show-more">
      <vm-modal-with-link uid="angular-contact-opening-hours" preLabel="*During our "></vm-modal-with-link>
    </div>
    <vm-modal
      *ngIf="showModal && selectedTile"
      [modalType]="modalType"
      [title]="selectedTile.heading"
      [hideHeader]="false"
      (closeButtonClick)="showModal = false">
      <div class="support-option-modal" [innerHtml]="selectedTile?.modal | markdown"></div>
    </vm-modal>
  </ng-container>

  <ng-content></ng-content>
</ng-container>
